module.exports = __webpack_public_path__ + "static/10-099e5180f07aaad701653b8cea380aa9.jpg";